import {
	Container,
	Service,
	track,
	DataService,
} from '../../../../symphony';

import { SlDataService } from '../sl-data.service';
import { ITrackActionData, TrackEventName } from '../../global-interface';
import { SlLEContext } from '../../../../learnEngine/private/global-constants';
import { SlDataService as LEDataService } from '../../../../learnEngine/private/services/sl-data.service';
import { lePlaygroundContext } from '../../global-constants';

@Service()
export class SlNewTrackingService {
	private data = Container.take(lePlaygroundContext.value, SlDataService);

	private leData = Container.take(SlLEContext, LEDataService);

	private globalData = Container.take('global', DataService);

	public onMaterialMount = async ({
		materialInfo,
	}: ITrackActionData): Promise<void> => {
		const trackData = {
			event_name: TrackEventName.MaterialImpression,
			dynamic_id: String(materialInfo.header.dynamicId || ''),
			material_id: String(materialInfo.header.materialId || ''),
			static_id: String(materialInfo.header.staticId || ''),
			material_type_id: String(materialInfo.header.typeId),
			experience_type_id: String(await this.globalData.getLETypeAsync()),
			experience_alias: this.leData.alias$.value,
			bundle_id: await this.leData.getBundleIdAsync(),
			page_id: '',
			version: '5-0-0',
		};
		track(trackData);
	};

	public materialSolve = (): void => {
		const trackData = {
			dynamic_id: String(this.data.materialData$.value.header.dynamicId || ''),
			material_id: String(this.data.materialData$.value.header.materialId || ''),
			static_id: String(this.data.materialData$.value.header.staticId || ''),
			event_name: TrackEventName.MaterialSolve,
			version: '4-0-0',
		};
		track(trackData);
	};

	public materialQuit = async ({
		quitAction,
	}: ITrackActionData): Promise<void> => {
		const trackData = {
			event_name: TrackEventName.MaterialQuit,
			relation_id: this.data.materialData$.value.header.materialRelationId,
			material_type_id: String(this.data.materialData$.value.header.typeId),
			experience_type_id: String(await this.globalData.getLETypeAsync()),
			experience_alias: this.leData.alias$.value,
			bundle_id: await this.leData.getBundleIdAsync(),
			action: quitAction,
			version: '3-0-0',
		};
		track(trackData);
	};

	public materialCTAClick = async ({
		materialCTAClickType,
	}: ITrackActionData): Promise<void> => {
		const trackData = {
			event_name: TrackEventName.MaterialCTAClick,
			dynamic_id: String(this.data.materialData$.value.header.dynamicId || ''),
			material_id: String(this.data.materialData$.value.header.materialId || ''),
			static_id: String(this.data.materialData$.value.header.staticId || ''),
			material_type_id: String(this.data.materialData$.value.header.typeId),
			experience_type_id: String(await this.globalData.getLETypeAsync()),
			experience_alias: this.leData.alias$.value,
			page_id: '',
			cta_type_id: materialCTAClickType,
			bundle_id: await this.leData.getBundleIdAsync(),
			version: '5-0-0',
		};
		track(trackData);
	};
}
